import { render, staticRenderFns } from "./IncrementInvestorContractLevel.vue?vue&type=template&id=20c56d46&"
import script from "./IncrementInvestorContractLevel.vue?vue&type=script&lang=js&"
export * from "./IncrementInvestorContractLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports